import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";
import { coursesBatchesList, lessonsList, sessionsList, adminsCoursesAndBatches, adminsSessionsList, attendanceList, channelPartnerCoursesAndBatches } from "constants/attendanceModule";

export const getCoursesBatchesList = async (
    dispatch,
    pageNum,
    filters,
    searchString,
) => {
    try {
        const res = await api.get_courses_batches(pageNum, filters, searchString);
        dispatch({ type: coursesBatchesList, payload: res.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: coursesBatchesList,
            payload: error?.response?.data || error,
        });
    }
};

export const getLessons = async (dispatch, courseId, batchId, pageNum, filters) => {
    try {
        const res = await api.get_lessons(courseId, batchId, pageNum, filters);
        dispatch({ type: lessonsList, payload: res.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: lessonsList,
            payload: error?.response?.data || error,
        });
    }
};

export const addAttendance = async (bodyData) => {
    try {
        const res = await api.add_attendance(bodyData);
        return res.data;
    } catch (error) {
        return error?.response?.data || error;
    }
};

export const getAttendanceList = async (dispatch, courseId, batchId, traineeId, pageNum) => {
    try {
        const res = await api.get_attendance_list(courseId, batchId, traineeId, pageNum);
        dispatch({ type: attendanceList, payload: res.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: attendanceList,
            payload: error?.response?.data || error,
        });
    }
};

export const updateAttendance = async (sessionId, bodyData) => {
    try {
        const res = await api.update_attendace(sessionId, bodyData);
        return res.data;
    } catch (error) {
        return error?.response?.data || error;
    }
}

export const getSessionList = async (dispatch, courseId, batchId, pageNum) => {
    try {
        const res = await api.get_session_list(courseId, batchId, pageNum);
        dispatch({ type: sessionsList, payload: res.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: sessionsList,
            payload: error?.response?.data || error,
        });
    }
};

export const getSessionByID = async (sessionId, pageNum, filterParams) => {
    try {
        const res = await api.get_session_by_id(sessionId, pageNum, filterParams);
        return res.data;
    } catch (error) {
        return error?.response?.data || error;
    }
};

export const getBatchScheduledDates = async (batchID) => {
    try {
        const res = await api.batch_scheduled_dates(batchID);
        return res.data;
    } catch (error) {
        return error?.response?.data || error;
    }
}

// Admins and Super Admins courses and batches list
export const getAdminsCoursesAndBatches = async (dispatch, pageNum, filters, searchString) => {
    try {
        const res = await api.get_admins_courses_and_batches(pageNum, filters, searchString);
        dispatch({ type: adminsCoursesAndBatches, payload: res?.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: adminsCoursesAndBatches,
            payload: error?.response?.data ?? { message: error?.message },
        });
    }
};

// Admins and Super Admins sessions list
export const getAdminsSessionsList = async (dispatch, courseId, batchId, pageNum) => {
    try {
        const res = await api.get_admins_sessions_list(courseId, batchId, pageNum);
        dispatch({ type: adminsSessionsList, payload: res.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: adminsSessionsList,
            payload: error?.response?.data || error,
        });
    }
};

// Admin and Super Admins sessions wise attendance list
export const getAdminsSessionsWiseAttendanceList = async (sessionId, pageNum, filterParams) => {
    try {
        const res = await api.get_admins_sessions_wise_attendance_list(sessionId, pageNum, filterParams);
        return res.data;
    } catch (error) {
        return error?.response?.data || error;
    }
};

// Channel Partner courses and batches list
export const getChannelPartnerCoursesAndBatches = async (dispatch, pageNum, filters, searchString) => {
    try {
        const res = await api.get_channel_partner_courses_and_batches(pageNum, filters, searchString);
        dispatch({ type: channelPartnerCoursesAndBatches, payload: res?.data });
    } catch (error) {
        authorizedUser(error?.response?.data);
        dispatch({
            type: channelPartnerCoursesAndBatches,
            payload: error?.response?.data ?? { message: error?.message },
        });
    }
};

// Channel Partner sessions wise attendance list
export const getChannelPartnerSessionsWiseAttendanceList = async (sessionId, pageNum, filterParams) => {
    try {
        const res = await api.get_channel_partner_sessions_wise_attendance_list(sessionId, pageNum, filterParams);
        return res.data;
    } catch (error) {
        return error?.response?.data || error;
    }
};